require('./brokerCustomWalletPortfolioEmptyState.scss');
// @ vendor
const PropTypes = require('prop-types');
const React = require('react');
// @ utils
const { formatText } = require('core/i18n').i18n;
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');

class BrokerCustomWalletPortfolioEmptyState extends React.Component {
    render() {
        const { onLeaveAction, isEmptyState } = this.props;
        let leaveEditionLink;
        let contractErrorStateText1 = formatText('brokerCustomWallet-contractErrorStateText1');
        let contractErrorStateText2 = formatText('brokerCustomWallet-contractErrorStateText2');

        if (isEmptyState) {
            contractErrorStateText1 = formatText('brokerCustomWallet-contractEmptyStateText1');
            contractErrorStateText2 = formatText('brokerCustomWallet-contractEmptyStateText2');
        }

        if (!!onLeaveAction) {
            leaveEditionLink = (<OKButton onClick={onLeaveAction}>
                {formatText('brokerCustomWallet-contractErrorStateLink')}
            </OKButton>);
        }

        const secondaryText = (
            <div className="broker-custom-wallet-empty-state">
                <span className="broker-custom-wallet-empty-state__text">
                    {contractErrorStateText1}
                </span>
                <span className="broker-custom-wallet-empty-state__text">
                    {contractErrorStateText2}
                </span>
                {leaveEditionLink}
            </div>
        );

        return <EmptyState secondaryText={secondaryText} iconType="nointernet-wealth"/>;
    }
}

BrokerCustomWalletPortfolioEmptyState.propTypes = {
    onLeaveAction: PropTypes.func,
    isEmptyState: PropTypes.bool
};

module.exports = BrokerCustomWalletPortfolioEmptyState;
